import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import React, { ComponentProps } from 'react';

import { TextField as BlocksTextField } from '~/components/blocks';

const Root = styled(BlocksTextField)<{ error?: string | boolean }>(
  ({ theme }) =>
    css({
      // iOSでズームがされないようにサイズを固定する
      fontSize: '16px',
      [`@media ${theme.mediaQueries.tablet}`]: {
        fontSize: '16px',
      },
      '&:hover': {
        border: theme.borders.grey,
      },
      '&:focus': {
        border: theme.borders.grey,
      },
    }),
  ({ theme, error }) =>
    error &&
    css({
      backgroundColor: theme.colors.background.patientSecondary,
      color: theme.colors.colorPallete.patientRed,
      '&:hover': {
        border: theme.borders.patientPrimary,
      },
      '&:focus': {
        border: theme.borders.patientPrimary,
      },
    }),
);

type Props = ComponentProps<typeof BlocksTextField>;

export const TextField = React.forwardRef((props: Props, ref: React.Ref<HTMLInputElement>) => {
  return <Root {...props} ref={ref} />;
});

TextField.displayName = 'TextField';
